<template>
  <div :class="[{purpose: this.data?.body?.purpose}]">
    <q-form @submit="this.onSubmit" class="form">
      <div class="form__item">
        <CustomInput
          :required="true"
          label="Высота стен (мм)"
          type="number"
          :value="this.formData.wall_height === 0 ? '0' : this.formData.wall_height || ''"
          @change_input="(value) => onChange('wall_height', value)"
        />
      </div>
      <div class="form__item">
        <CustomInput
          :required="true"
          label="Высота дверей (мм)"
          type="number"
          :value="this.formData.door_height === 0 ? '0' : this.formData.door_height || ''"
          @change_input="(value) => onChange('door_height', value)"
        />
      </div>
      <div class="form__item">
        <CustomInput
          :required="true"
          label="Высота окон (мм)"
          type="number"
          :value="this.formData.window_height === 0 ? '0' : this.formData.window_height || ''"
          @change_input="(value) => onChange('window_height', value)"
        />
      </div>
      <div class="form__item">
        <CustomInput
          label="1 unit автокад равен X пикселям"
          type="number"
          :value="this.formData.scale === 0 ? '0' : this.formData.scale || ''"
          @change_input="(value) => onChange('scale', value)"
        />
      </div>
      <div class="form__item">
        <CustomInput
          label="1 длина автокад равна X мм"
          type="number"
          :value="this.formData.autocad_scale === 0 ? '0' : this.formData.autocad_scale || ''"
          @change_input="(value) => onChange('autocad_scale', value)"
        />
      </div>
      <div class="form__item">
        <CustomInput
          label="Min X"
          type="number"
          :allowNegative="true"
          :value="this.formData.min_x === 0 ? '0' : this.formData.min_x || ''"
          @change_input="(value) => onChange('min_x', value)"
        />
      </div>
      <div class="form__item">
        <CustomInput
          label="Min Y"
          type="number"
          :allowNegative="true"
          :value="this.formData.min_y === 0 ? '0' : this.formData.min_y || ''"
          @change_input="(value) => onChange('min_y', value)"
        />
      </div>
      <div class="form__item">
        <CustomInput
          label="Max Y"
          type="number"
          :allowNegative="true"
          :value="this.formData.max_y === 0 ? '0' : this.formData.max_y || ''"
          @change_input="(value) => onChange('max_y', value)"
        />
      </div>
      <div class="form__item">
        <CustomInput
          label="Ширина откоса"
          type="number"
          :value="this.formData.slope_width === 0 ? '0' : this.formData.slope_width || ''"
          @change_input="(value) => onChange('slope_width', value)"
        />
      </div>
      <div class="form__item">
        <CustomInput
          label="Код"
          :value="this.formData.code || ''"
          @change_input="(value) => onChange('code', value)"
        />
      </div>
      <div class="form__item">
        <CustomInput
          label="Комментарий"
          type="textarea"
          :value="this.formData.comments || ''"
          @change_input="(value) => onChange('comments', value)"
        />
      </div>

      <div class="form__item">
        <CustomUploader
          :value="this.formData?.image"
          :on-change="(value) => this.onChange('image', value)"
          title="Подложка"
        />
      </div>

      <div class="form__item">
        <CustomUploader
          :value="this.formData?.autocad"
          :on-change="(value) => this.onChange('autocad', value)"
          title="Исходники AutoCAD"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomUploader from "@/components/form/CustomUploader";
import CustomInput from "@/components/form/CustomInput";
import { addFloorMap, editFloorMap } from "@/views/BuildingSettings/services";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import { useAppStore } from "@/services/store/app";

export default {
  name: "add-floor-map",
  components: {CustomInput, CustomUploader, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        wall_height: '',
        door_height: '',
        window_height: '',
        autocad_scale: '',
        scale: '',
        min_y: '',
        min_x: '',
        max_y: '',
        slope_width: '',
        comments: '',
        code: '',
        image: null,
        autocad: null,
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      let formData = new FormData()

      Object.keys(this.formData).forEach((key) => {
        if(this.formData[key] === null || this.formData[key] === undefined || this.formData[key] === 'undefined') return formData.append(key, '')
        if(key === 'image' || key === 'autocad') return
        formData.append(key, this.formData[key])
      })

      if (this.formData.image) {
        formData.append('image', this.formData.image[0])
      } else {
        formData.delete('image')
      }

      if (this.formData.autocad) {
        formData.append('autocad', this.formData.autocad[0])
      } else {
        formData.delete('autocad')
      }

      this.loading = true
      await this.handleEditFloorMap(formData)
      this.loading = false
    },
    async handleEditFloorMap(body) {
      let res = null
      if(this.data?.isEdit) {
        res = await editFloorMap(this.data?.floor_map_id, body, this.data?.params)
      } else {
        res = await addFloorMap(body, this.data?.params)
      }
      if (!res) return
      if(this.data?.onSubmit)
        await this.data?.onSubmit(res)
      this.showSucceedSnackbar()
      this.closeModal()
    }
  },
  mounted() {
    if(this.data?.body) {
          const {
          resident_id,
          level_num,
          wall_height,
          door_height,
          window_height,
          autocad_scale,
          scale,
          min_y,
          min_x,
          max_y,
          code,
          slope_width,
          comments
        } = this.data.body
      this.formData = {
        ...this.formData, wall_height,
          door_height,
          window_height,
          comments,
          resident_id,
          level_num,
          autocad_scale,
          scale,
          min_y,
          min_x,
          max_y,
          slope_width,
          code,
          }
    }
  },
  setup() {
    const {closeModal} = useAppStore()
    const {showSucceedSnackbar} = useCustomSnackbar()
    return {showSucceedSnackbar, closeModal}
  }
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 15px;

  &__item {
    &_file {
      padding: 10px 7px;
      border-radius: 4px;
      border: 1px solid #ccc;
      color: #1f5ac2;

      &Label {
        margin-bottom: 3px;
        font-size: 13px;
        display: block;
        color: #3b3b3b;
      }
    }
  }

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>
